import useAxios from '../../hooks/useAxios';
import React, { useEffect, useRef, useState } from 'react';
import Titel from './Titel';
import New_Edit_Modal from './New_Edit._Modal_About';
import RichTextEditor from '../TextEditor';

const About = () => {
    const { AxiosPrivate } = useAxios()
    const [desc, setDesc] = useState()
    const [data, setData] = useState([])
    const [reload, setReload] = useState()
    const update = useRef(null)
    useEffect(() => {
        const get = async () => {
            await AxiosPrivate.get('/about-us')
                .then(res => {
                    setDesc(res.data.data.body)
                    update.current.innerText = `ویرایش: ${new Date(res.data.data.updated_at).toLocaleString('fa-IR')}`
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
            await AxiosPrivate.get('/member')
                .then(res => setData(res.data.data.data))
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
        get()
    }, [reload])

    const handleSumbit = async () => {
        if (desc.trim().length < 50) {
            alert('متن درباره ما حداقل باید 50 کارکتر باشد')
            return
        } else
            await AxiosPrivate.post('/about-us/update', { title: '', body: desc, _method: "PUT" })
                .then(res => {
                    alert(res.data.messgae || 'با موفقیت ویرایش شدند')
                    setReload(Math.random())
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
    }

    const handleDelete = async (id) => {
        if (window.confirm("آیا از حذف این هنرمند اطمینان دارید")) {
            await AxiosPrivate.delete(`/member/delete/${id}`)
                .then(res => {
                    setData(prev => prev.filter(c => c.id !== id))
                    alert(res.data.message)
                }).catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
        }
    }

    return (
        <>
            <div className="">
                <div className="">
                    <Titel title='متن درباره ما' className='mb-6' />
                    <div className="w-full flex sm:items-center items-start gap-4 mb-4 sm:text-base text-sm sm:flex-row flex-col">
                        <p ref={update}></p>
                    </div>
                    <div className="relative w-full">
                        <RichTextEditor value={desc} onChange={setDesc} />
                    </div>
                    <button onClick={handleSumbit} type="button" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                     focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 my-3">ویرایش</button>
                </div>
                <div className="">
                    <Titel title='اعضای تیم' className='my-6' />
                    <div className=" flex flex-col gap-4">
                        <p className='text-sm'>جهت تغییرات روی مداد کلیک کنید</p>
                        <div className="flex flex-wrap gap-4">
                            {data.map(t => {
                                return (
                                    <div key={t.id} className="group relative w-[200px] centerOfParent flex-col border p-2 gap-2 cursor-pointer rounded-lg hover:shadow-lg duration-300">
                                        <p className='line-clamp-1'>{t.title}</p>
                                        <span className='text-xs'>{t.post}</span>
                                        <div className="absolute flex left-1 top-1 lg:opacity-0 opacity-100 group-hover:opacity-100 duration-300 z-10">
                                            <New_Edit_Modal edit={true} url='member' data={t} setReload={setReload} />
                                            <div onClick={() => handleDelete(t.id)} className='hover:bg-gray-300 cursor-pointer duration-250 rounded-full p-1'><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg></div>
                                        </div>
                                    </div>
                                )
                            })}
                            <New_Edit_Modal setReload={setReload} url='member' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;